import config from './config';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

//kaita!
//import AnotherApp from './components/calendar/index';
//import './components/calendar/index.css';
//kokomade

// console.log('endpoint', config);

// reandering ReactDOM
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

//kaita!
//ReactDOM.render(<AnotherApp />, document.getElementById('root2'));
//registerServiceWorker();
//kokomade



// WEBPACK FOOTER //
// ./src/index.js